import { FormSpy } from 'react-final-form';
import { useCallback, useState } from 'react';

import { KnmAttachmentsSigning } from 'KnmPackage/MainModule/components/KnmAttachmentsSigning';
import { IKnmFormAttachment } from 'KnmPackage/MainModule/interfaces/IKnmFormAttachment';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Button } from 'UIPackage/MainModule/components/Button';

import { IKnmFormRef } from '../../../KnmPackage/MainModule/interfaces/IKnmFormRef';

interface IPmSuspensionEventsAttachmentsProps {
  attachments?: IKnmFormAttachment[];
  formFieldName: string;
  formRef: IKnmFormRef | undefined;
  isWatchOnly: boolean;
  sIndex: number;
  suspensionEventFieldName: string;
}

export const PmSuspensionEventsAttachments = ({
  attachments,
  formFieldName,
  formRef,
  isWatchOnly,
  sIndex,
  suspensionEventFieldName,
}: IPmSuspensionEventsAttachmentsProps) => {
  const [isVisibleSignModal, setIsVisibleSignModal] = useState<boolean>(false);

  const handleOpenSignModal = useCallback(() => {
    setIsVisibleSignModal(true);
  }, []);

  const handleCloseSignModal = useCallback(() => {
    setIsVisibleSignModal(false);
  }, []);

  return (
    <>
      <FieldBlock>
        <label className="shared-field-label_row" htmlFor="event">
          Файл решения
        </label>
        {!attachments?.length && (
          <Button
            className="shared-btn-add"
            text="Добавить"
            type="button"
            variant="link"
            color="primary"
            onClick={handleOpenSignModal}
            disabled={isWatchOnly}
          />
        )}
      </FieldBlock>
      <FormSpy subscription={{ errors: true, touched: true }}>
        {props => {
          const fieldError = props.errors?.[formFieldName]?.[sIndex]?.attachments;
          const isFieldTouched = props.touched?.[`${suspensionEventFieldName}.attachments`];

          if (fieldError && isFieldTouched) {
            return <p className="shared-input-error shared-row__small-margin">{fieldError}</p>;
          }

          return null;
        }}
      </FormSpy>
      <KnmAttachmentsSigning
        name={`${suspensionEventFieldName}.attachments`}
        isVisibleSignModal={isVisibleSignModal}
        closeSignModal={handleCloseSignModal}
        acceptedFiles=".pdf,.png,.jpeg,.ktd,.rtf,.rar,.zip"
        isWatchOnly={isWatchOnly}
        formRef={formRef}
      />
    </>
  );
};
